module.exports = __webpack_public_path__ + "bbcb34309fffa4f68149a425d8166885.pdf";